/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ created: NonNullable<unknown>, existing: NonNullable<unknown> }} History_Transfer_Done_BodyInputs */

const en_us2_history_transfer_done_body = /** @type {(inputs: History_Transfer_Done_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} workouts added, ${i?.existing} were already here.`)
};

const pt_br2_history_transfer_done_body = /** @type {(inputs: History_Transfer_Done_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} treinos adicionados, ${i?.existing} já estavam aqui.`)
};

const es_419_history_transfer_done_body = /** @type {(inputs: History_Transfer_Done_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} entrenamientos agregados, ${i?.existing} ya estaban aquí.`)
};

const pt_pt2_history_transfer_done_body = /** @type {(inputs: History_Transfer_Done_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} treinos adicionados, ${i?.existing} já estavam cá.`)
};

const fr_fr2_history_transfer_done_body = /** @type {(inputs: History_Transfer_Done_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} séances ajoutées, ${i?.existing} étaient déjà là.`)
};

const de_de2_history_transfer_done_body = /** @type {(inputs: History_Transfer_Done_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} Trainings hinzugefügt, ${i?.existing} waren schon da.`)
};

const it_it2_history_transfer_done_body = /** @type {(inputs: History_Transfer_Done_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.created} allenamenti aggiunti, ${i?.existing} erano già qui.`)
};

/**
* | output |
* | --- |
* | "{created} workouts added, {existing} were already here." |
*
* @param {History_Transfer_Done_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_done_body = /** @type {((inputs: History_Transfer_Done_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Done_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_done_body(inputs)
	if (locale === "es-419") return es_419_history_transfer_done_body(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_done_body(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_done_body(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_done_body(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_done_body(inputs)
	return en_us2_history_transfer_done_body(inputs)
});
export { history_transfer_done_body as "history-transfer.done_body" }